import React from "react"

export const ErrorImage = () => (
  <svg height="120" width="261" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        d="M25.412 97c-.264-.804-.412-7.977-.412-8.871C25 83.639 28.603 80 33.047 80c3.833 0 7.034 2.709 7.844 6.333a5.115 5.115 0 0 1 2.31-.553c1.48 0 2.813.63 3.758 1.636.96-2.257 3.18-3.837 5.765-3.837 3.466 0 6.276 2.838 6.276 6.34 0 .26-.02 6.83-.05 7.081z"
        fill="#d5dee3"
      />
      <path
        d="M66.78 98c.632-1.882.987-3.888.987-5.98 0-10.504 5.127-19.02-5.53-19.02-9.191 0-16.867 6.339-18.81 14.818a12.514 12.514 0 0 0-5.539-1.294 12.474 12.474 0 0 0-9.012 3.827c-2.305-5.279-7.626-8.976-13.826-8.976C6.738 81.375 0 88.015 0 96.207c0 .608.049 1.204.12 1.793z"
        fill="#eaeff1"
      />
      <path
        d="M217.376 74c-.24-.71-.376-7.039-.376-7.828 0-3.96 3.285-7.172 7.337-7.172 3.495 0 6.413 2.39 7.152 5.588a4.79 4.79 0 0 1 5.532.955c.877-1.99 2.9-3.385 5.257-3.385 3.16 0 5.722 2.504 5.722 5.593 0 .23-.018 6.027-.046 6.249z"
        fill="#d5dee3"
      />
      <path
        d="M205.114 57c8.253 0 15.145 5.578 16.89 13.04a11.426 11.426 0 0 1 4.974-1.138c3.189 0 6.057 1.297 8.092 3.367 2.07-4.646 6.848-7.9 12.416-7.9 7.464 0 13.514 5.845 13.514 13.054 0 .534-.044 1.058-.108 1.577h-55.83c-.083-2.184-.083-3.822 0-4.914.293-3.797.31-9.492.052-17.086z"
        fill="#eaeff1"
      />
      <path
        d="M39.11 110c10.554 0 21.89-1.343 21.89-3s-11.336-3-21.89-3S20 105.343 20 107s8.556 3 19.11 3z"
        fill="#f5f7f8"
      />
      <path
        d="M39.484 63.71c-.175.507-.197.99-.064 1.451.218.76.831 1.308 1.839 1.642L41.099 69l-5.358-.332-.387-2.893 1.368-2.63c-.418-.135-.627-.246-.627-.334 0-.161-.365-1.765-1.095-4.811h5.07c1.001.38 1.62 1.153 1.858 2.32.355 1.75-.672 2.867-1.494 3.216-.27.114-.587.172-.95.174zm6.458 9.455c.26.755-.351 3.7-1.831 8.835H42.32l1.426-8.2L41 70.79 43.746 69c1.205 2.022 1.937 3.41 2.196 4.165z"
        fill="#eef1f3"
      />
      <path
        d="M34 72.442L36.878 80h7.107l-.035-.45-1.612-7.108c.97-1.302 1.52-2.241 1.647-2.816s-.557-1.254-2.051-2.036c-.402.638-1.308.957-2.718.957S36.654 68.03 35.76 67z"
        fill="#cbd6dc"
      />
      <path
        d="M43.787 105.816v.583L46 108h-4.612v-2.184l-1.49-15.703-1.49 15.703v.583L40.62 108h-4.612v-2.184h-.002c-1.404-8.04-2.071-13.933-2.002-17.683s.9-6.793 2.496-9.133H43.686l1.575 9.133-1.473 17.683z"
        fill="#a9bac4"
      />
      <path
        d="M33.692 68L32 77.45l5.452 6.246a.891.891 0 0 0 1.2.13.843.843 0 0 0 .19-1.16l-4.16-5.953 1.752-7.646z"
        fill="#eef1f3"
      />
      <path
        d="M42.185 57.172c.285-1.566-1.248-3.164-3.533-3.051-4.562.1-6.599 3.19-6.111 9.27-2.254 1.216-3.493 2.775-3.717 4.68-.245 2.443 3.27 4.312 5.793 3.777 1.683-.357 2.356-2.322 2.021-5.895.838-.935 1.338-1.874 1.503-2.818.164-.945-.34-2.257-1.513-3.937 3.515-.307 5.367-.982 5.557-2.026z"
        fill="#a9bac4"
      />
      <path
        d="M58.19 1h144.62c.657 0 1.19.533 1.19 1.19V9H57V2.19c0-.657.533-1.19 1.19-1.19z"
        fill="#eaeff1"
      />
      <rect fill="#dde3e7" height="20" rx="2" width="4" x="88" y="32" />
      <rect fill="#cbd6dc" height="25" rx="2" width="4" x="98" y="26" />
      <rect fill="#dde3e7" height="17" rx="2" width="4" x="108" y="35" />
      <rect fill="#cbd6dc" height="31" rx="2" width="4" x="117" y="21" />
      <rect fill="#dde3e7" height="24" rx="2" width="4" x="127" y="28" />
      <rect fill="#dde3e7" height="18" rx="2" width="4" x="137" y="33" />
      <rect fill="#cbd6dc" height="28" rx="2" width="4" x="147" y="24" />
      <rect fill="#cbd6dc" height="22" rx="2" width="4" x="157" y="29" />
      <g fill="#dde3e7">
        <rect height="10" rx="2" width="4" x="166" y="42" />
        <rect height="17" rx="2" width="4" x="176" y="35" />
        <rect height="21" rx="2" width="4" x="186" y="31" />
        <rect height="7" rx="2" width="4" x="196" y="45" />
      </g>
      <path d="M57 21h25v75H58.19A1.19 1.19 0 0 1 57 94.81z" fill="#f5f7f8" />
      <path d="M57 13h25v6H57z" fill="#d5dee3" />
      <path d="M88 63h53v3H88z" fill="#dde3e7" />
      <path d="M88 75h74v3H88z" fill="#cbd6dc" />
      <path d="M88 88h64v3H88z" fill="#dde3e7" />
      <path
        d="M58.384 2.005a.38.38 0 0 0-.38.38v93.23c0 .21.17.38.38.38h145.232c.21 0 .38-.17.38-.38V2.384a.38.38 0 0 0-.38-.38zm0-2.005h145.232A2.385 2.385 0 0 1 206 2.386v93.228A2.385 2.385 0 0 1 203.616 98H58.384A2.385 2.385 0 0 1 56 95.614V2.386A2.385 2.385 0 0 1 58.384 0z"
        fill="#a9bac4"
        fillRule="nonzero"
      />
      <path
        d="M184.11 120c10.554 0 21.89-1.343 21.89-3s-11.336-3-21.89-3-19.11 1.343-19.11 3 8.556 3 19.11 3z"
        fill="#f5f7f8"
      />
      <path
        d="M189.849 112.152c-7.263-5.13-10.959-8.353-11.088-9.669-.129-1.316.68-4.98 2.424-10.99l4.824 1.588-2.522 8.997 8.559 7.587.002-.003 1.88 1.47-4.693 5.132.595-4.092zm-2.401 2.6l.24 2.138-6.563.749 3.359-2.42.339-.91z"
        fill="#a9bac4"
      />
      <path
        d="M182.907 91.416l1.345 10.954.08 11.218 2.708.493 1.02-11.31 1.656-10.97z"
        fill="#a9bac4"
      />
      <path d="M180.632 80.407l.11 11.731 1-1.943.516-10.333z" fill="#eef1f3" />
      <path
        d="M180.798 91.397l.729-10.564-1.337.165c-.159-1.147.084-2.143.73-2.99.644-.846 1.564-1.376 2.76-1.592 4.626-1.08 7.446-.468 8.46 1.833.496 1.161.375 2.71-.361 4.644l-1.593 4.589-.62 5.205c-2.755.076-4.735.026-5.942-.152s-2.148-.557-2.826-1.138z"
        fill="#cbd6dc"
      />
      <path
        d="M187.919 80.558c.59.457 1.093.767 1.509.93.416.164 1.207.313 2.375.448-1.676 2.75-3.09 4.312-4.243 4.687-1.103.36-4.5-.577-10.188-2.809a.854.854 0 0 1-.493-1.08.937.937 0 0 1 1.083-.602l8.514 1.857zM186.586 75.033l-.203 1.665a1.48 1.48 0 0 1-1.671 1.288 1.53 1.53 0 0 1-1.31-1.7l.187-1.55a4.59 4.59 0 0 1-2.588-4.23c.044-2.532 2.094-4.549 4.579-4.505 2.485.043 4.463 2.13 4.42 4.662-.038 2.121-1.484 3.882-3.414 4.37z"
        fill="#eef1f3"
      />
      <path
        d="M187.954 71.569c.623-.262 1.036-1.193 1.091-1.586.068-.482-.236-.884-.732-.993-.497-.108-.947.299-1.128.875l-.063.202c-.89-.16-1.464-.674-1.719-1.543-2.798.479-4.262-.01-4.39-1.465-.194-2.183 1.803-2.692 2.7-2.922 1.262-.291 6.711-.448 8.058 3.085.744 2.195-.51 4.803-1.162 5.752s-1.416 1.287-2.145.817c-.547-.353-.742-.965-.51-2.222z"
        fill="#a9bac4"
      />
    </g>
  </svg>
)
